import { render, staticRenderFns } from "./ElementNotSupportedModal.vue?vue&type=template&id=36c51786"
import script from "./ElementNotSupportedModal.vue?vue&type=script&lang=js"
export * from "./ElementNotSupportedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports